import { formatDate2, formatPhoneNumber } from '../../../../../../utils';

interface IApplicationInformationDetailsProps {
  applicationInformation: {
    neighborhood: string;
    hasAssets: string;
    receivedAssistance: string;
    city: string;
    disabled: string;
    dob: string;
    gender: string;
    phone?: string;
    maritalStatus: string;
    name: string;
    race?: string[];
    state: string;
    streetAddress: string;
    zipCode: string;
    doChildrenLive: string;
    requestedInsurance: string;
    wasBuiltBefore1978: string;
  };
}
export default function ApplicationInformationDetails({ applicationInformation }: IApplicationInformationDetailsProps) {
  return (
    <section aria-labelledby='applicant-information-title'>
      <div className='bg-white shadow sm:rounded-lg'>
        <div className='py-5'>
          <div className='px-4 py-2 sm:px-6 border-l-4 border-primaryColor-normal'>
            <h2 id='applicant-information-title' className='m-0 text-lg leading-6 font-medium text-primaryColor-normal'>
              Application Information
            </h2>
          </div>
        </div>
        <div className='border-t border-gray-200 px-4 py-5 sm:px-6 flex flex-col gap-6'>
          <div className='space-y-6'>
            <dl className='grid grid-cols-1 gap-x-4 gap-y-8 sm:grid-cols-2'>
              <div className='sm:col-span-1'>
                <dt className='text-sm font-medium text-gray-500'>Name</dt>
                <dd className='mt-1 text-sm text-gray-900'>{applicationInformation?.name}</dd>
              </div>
              <div className='sm:col-span-1'>
                <dt className='text-sm font-medium text-gray-500'>Address</dt>
                <dd className='mt-1 text-sm text-gray-900'>
                  {applicationInformation?.streetAddress}, {applicationInformation?.city}, {applicationInformation?.state},{' '}
                  {applicationInformation?.zipCode}
                </dd>
              </div>
            </dl>
            <dl className='grid grid-cols-1 gap-x-4 gap-y-8 sm:grid-cols-2'>
              <div className='sm:col-span-1'>
                <dt className='text-sm font-medium text-gray-500'>Phone</dt>
                <dd className='mt-1 text-sm text-gray-900'>
                  {applicationInformation?.phone ? ` ${formatPhoneNumber(applicationInformation?.phone)}` : 'None'}
                </dd>
              </div>
              <div className='sm:col-span-1'>
                <dt className='text-sm font-medium text-gray-500'>Date of Birth</dt>
                <dd className='mt-1 text-sm text-gray-900'>{formatDate2(applicationInformation?.dob)}</dd>
              </div>
            </dl>
            <dl className='grid grid-cols-1 gap-x-4 gap-y-8 sm:grid-cols-2'>
              <div className='sm:col-span-1'>
                <dt className='text-sm font-medium text-gray-500'>Neighborhood</dt>
                <dd className='mt-1 text-sm text-gray-900'>{applicationInformation?.neighborhood}</dd>
              </div>
              <div className='sm:col-span-1'>
                <dt className='text-sm font-medium text-gray-500'>Gender</dt>
                <dd className='mt-1 text-sm text-gray-900 capitalize'>{applicationInformation?.gender}</dd>
              </div>
            </dl>
            <dl className='grid grid-cols-1 gap-x-4 gap-y-8 sm:grid-cols-2'>
              <div className='sm:col-span-1'>
                <dt className='text-sm font-medium text-gray-500'>Marital Status</dt>
                <dd className='mt-1 text-sm text-gray-900'>{applicationInformation?.maritalStatus}</dd>
              </div>
              <div className='sm:col-span-1'>
                <dt className='text-sm font-medium text-gray-500'>Do you have $5,000+ in Assets</dt>
                <dd className='mt-1 text-sm text-gray-900 capitalize'>{applicationInformation?.hasAssets}</dd>
              </div>
              <div className='sm:col-span-1'>
                <dt className='text-sm font-medium text-gray-500'>Received assistance in 3 years</dt>
                <dd className='mt-1 text-sm text-gray-900 capitalize'>{applicationInformation?.receivedAssistance}</dd>
              </div>
              <div className='sm:col-span-1'>
                <dt className='text-sm font-medium text-gray-500'>Was the house built before 1978?</dt>
                <dd className='mt-1 text-sm text-gray-900 capitalize'>{applicationInformation?.wasBuiltBefore1978}</dd>
              </div>
              <div className='sm:col-span-1'>
                <dt className='text-sm font-medium text-gray-500'>Flood Insurance Required & Requested?</dt>
                <dd className='mt-1 text-sm text-gray-900 capitalize'>{applicationInformation?.requestedInsurance}</dd>
              </div>
              <div className='sm:col-span-1'>
                <dt className='text-sm font-medium text-gray-500'>
                  Do children less than 6 years old live/spend substantial time in this house?
                </dt>
                <dd className='mt-1 text-sm text-gray-900 capitalize'>{applicationInformation?.doChildrenLive}</dd>
              </div>
              <div className='sm:col-span-1'>
                <dt className='text-sm font-medium text-gray-500'>Races</dt>
                <dd className='mt-1 text-sm text-gray-900 capitalize'>
                  {applicationInformation?.race ? applicationInformation?.race.map((r, index) => <li key={index}>{r}</li>) : 'None'}
                </dd>
              </div>
            </dl>
          </div>
        </div>
      </div>
    </section>
  );
}
